import { Droppable } from '@hello-pangea/dnd';
import { KanbanTask } from './kanban-task';
import type { Task, TaskStatus } from '@/lib/types';

interface KanbanColumnProps {
  status: TaskStatus;
  tasks: Task[];
}

export function KanbanColumn({ status, tasks }: KanbanColumnProps) {
  return (
    <div className="bg-gray-50 dark:bg-gray-800 rounded-lg shadow flex flex-col h-[calc(100vh-100px)]">
      <div className="p-4 border-b border-gray-200 dark:border-gray-700">
        <div className="flex items-center justify-between">
          <h3 className="font-medium">{status}</h3>
          <span className="text-sm text-gray-500 dark:text-gray-400">
            {tasks.length}
          </span>
        </div>
      </div>

      <Droppable droppableId={status}>
        {(provided) => (
          <div
            ref={provided.innerRef}
            {...provided.droppableProps}
            className="p-4 space-y-4 flex-1 overflow-y-auto scrollbar-hide"
          >
            {tasks.map((task, index) => (
              <KanbanTask key={task.id} task={task} index={index} />
            ))}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </div>
  );
}